// Apopilo change signal: every state change (create, edit, take, withdraw, accept, reject, cancel, post again, delete, rate)
// calls invalidateApopilo on success and on a 409 APOPILO_* (the state changed under the user).
import { useQuery, type QueryClient } from "@tanstack/react-query";
import { getApopiloMe } from "../api/apopilo";

/** Non-feed keys: post detail, the balance card, the requests list, the per-type counts. */
export const APOPILO_KEYS = ["wallPost", "apopiloMe", "apopiloRequests", "typeCounts"] as const;

/**
 * Feeds that can show offers: World (APOPILO and the rest), the user walls (Apopilo tab, My wall), Following and the
 * General Wall. GC walls and their search never hold offers; World search results are left alone, since each refetch
 * re-runs every loaded page against the search rate limit and can reorder the list under the reader.
 */
export const APOPILO_FEED_EXCLUDED = ["gc", "gcSearch", "off", "worldSearch"] as const;

export function invalidateApopilo(qc: QueryClient): void {
  void qc.invalidateQueries({
    predicate: (q) => q.queryKey[0] === "wallFeed" && !(APOPILO_FEED_EXCLUDED as readonly unknown[]).includes(q.queryKey[1]),
  });
  for (const k of APOPILO_KEYS) void qc.invalidateQueries({ queryKey: [k] });
}

/** The caller's balance, counts and the IEUP team account. */
export function useApopiloMe(enabled = true) {
  return useQuery({ queryKey: ["apopiloMe"], queryFn: getApopiloMe, enabled });
}
